export default __webpack_public_path__ + "47daf5973c8798075f314a593f219f18.svg";